export enum BillingMethodEnum {
    Manual = 'Manual',
    QRCode = 'QRCode',
    Automatic = 'Automatic'
}